export default __webpack_public_path__ + "static/development-79403ec79743fd07c2a10a7d45fc7575.jpg";